import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription, Subject} from 'rxjs';
import { ContactServices } from '../_services/contacts.services';
import { HelperServices } from '../_services/helper.services';
import { exhaustMap, map } from 'rxjs/operators';
import { ContactModel } from '../_models/contact.model';
import { AuthService } from '../../modules/auth/_services/auth.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements
OnInit, 
OnDestroy {

  isLoading: boolean;
  templateView: number = 1;
  private subscriptions: Subscription[] = []; 

  constructor(
    public contactService: ContactServices,
    private auth: AuthService,
    public helperService: HelperServices
  ) { }

  ngOnInit(): void {

    this.contactService.fetch();

    const sb1 = this.contactService.isLoading$.subscribe(res => this.isLoading = res);
    this.subscriptions.push(sb1);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

}
